import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormModule } from '@spaq/shared/components/forms';
import { PipesModule } from '@spaq/shared/pipes.module';
import { SharedCommonModule } from '@spaq/shared/shared-common.module';
import { SharedComponentsModule } from '@spaq/shared/shared-components.module';
import { TranslateModule } from '@ngx-translate/core';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GridModule } from '@progress/kendo-angular-grid';
import {
	ServiceDetailComponent,
	ServiceDetailDebugComponent,
	ServicesDirectoryComponent,
	ServicesListComponent,
	ServicesSelectComponent,
	ServicesSelectPaymentComponent
} from './components';
import { ContractModule } from '@spaq/modules/contract';
import { ServiceAcceptConditionsComponent } from '@spaq/modules/services/components/service-accept-conditions.component';
import { UtilsModule } from '@spaq/modules/utils';
import { TooltipModule } from '@progress/kendo-angular-tooltip';

@NgModule({
	imports: [
		PipesModule,
		GridModule,
		DropDownsModule,
		DatePickerModule,
		TranslateModule,
		SharedComponentsModule,
		FormModule,
		SharedCommonModule,
		UtilsModule,
		TooltipModule
	],

	declarations: [
		ServicesListComponent,
		ServiceDetailComponent,
		ServicesSelectComponent,
		ServicesDirectoryComponent,
		ServicesSelectPaymentComponent,
		ServiceDetailDebugComponent,
		ServiceAcceptConditionsComponent
	],
	exports: [
		ServicesListComponent,
		ServiceDetailComponent,
		ServicesSelectComponent,
		ServicesDirectoryComponent,
		ServicesSelectPaymentComponent
	]
})
export class ServicesModule {
	static forRoot(): ModuleWithProviders<ServicesModule> {
		return {
			ngModule: ServicesModule,
			providers: []
		};
	}
}
